<template>
  <img v-if="this.$store.state.isMobile" @click.stop.prevent="$emit('clicked')" alt="Click button to proceed"
       :class="['btn-next',{'logged-in':isLoggedIn}]" src="@/assets/front-arrow.png" />
</template>
<script>
export default {
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
};
</script>
<style lang="scss" scoped>
  .btn-next {
    display: block;
    max-width: 90px;
    z-index: 2;
    cursor: pointer;
    position: sticky;
    bottom: 10vw;
    left: 74vw;
  }

  @media (orientation: landscape) {

    .btn-next {
      left: 84vw;
      bottom: 5vw;
    }
  }

  .logged-in {
    bottom: 27vw !important;
  }
</style>
